var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle2, _circle3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle4, _circle5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 12.5,
    width: 22,
    height: 13,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8889,
    y: 21.9775,
    width: 3.26667,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8889,
    y: 14.3555,
    width: 4.35556,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3333,
    y: 14.3555,
    width: 1.63333,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 14.3555,
    width: 3.26667,
    height: 3.26667,
    rx: 1,
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2444,
    y: 21.9775,
    width: 4.35556,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6778,
    cy: 21.4331,
    r: 1.63333,
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9556,
    cy: 21.4331,
    r: 1.63333,
    fill: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 2.5,
    width: 22,
    height: 13,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8889,
    y: 11.9775,
    width: 3.26667,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8889,
    y: 4.35547,
    width: 4.35556,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3333,
    y: 4.35547,
    width: 1.63333,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 4.35547,
    width: 3.26667,
    height: 3.26667,
    rx: 1,
    fill: "#333333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2444,
    y: 11.9775,
    width: 4.35556,
    height: 1.08889,
    rx: 0.544444,
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6778,
    cy: 11.4331,
    r: 1.63333,
    fill: "#333333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9556,
    cy: 11.4331,
    r: 1.63333,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3001 14C22.3001 19.2467 18.0468 23.5 12.8 23.5C7.55334 23.5 3.30005 19.2467 3.30005 14C3.30005 8.75329 7.55334 4.5 12.8 4.5C18.0468 4.5 22.3001 8.75329 22.3001 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8825 17.1283C11.2129 17.1283 10.7572 16.8028 10.7572 16.2448C10.7572 15.7426 11.1664 15.3985 11.8918 15.3427L13.51 15.2311V15.9007C13.51 16.654 12.7288 17.1283 11.8825 17.1283ZM10.4596 19.6766C11.65 19.6766 12.8962 19.1558 13.4356 18.1513H13.51V19.5278H17.23V12.5062C17.23 10.4229 15.3235 9 12.4777 9C9.4831 9 7.6231 10.3857 7.5301 12.5806H10.9339C10.9897 12.0597 11.4919 11.6319 12.2731 11.6319C12.9892 11.6319 13.51 12.0039 13.51 12.6922V13.1944L11.2594 13.3339C8.5159 13.5013 7 14.5708 7 16.5424C7 18.3931 8.5903 19.6766 10.4596 19.6766Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNum);
export default __webpack_public_path__ + "static/media/PageNum.4f460dd5e03034cf3c83b27db810b19c.svg";
export { ForwardRef as ReactComponent };